import { Nullable } from "@tager/admin-services";

import { TermLinkType } from "@/typings/model";
import {
  TermLinkCreationPayload,
  TermLinkUpdatePayload,
} from "@/services/requests";

export type FormValues = {
  label: string;
  url: string;
};

export function convertTermLinkToFormValues(
  term: Nullable<TermLinkType>
): FormValues {
  if (!term) {
    return {
      label: "",
      url: "",
    };
  }
  return {
    label: term.label ?? "",
    url: term.url ?? "",
  };
}

export function convertFormValuesToTermLinkCreationPayload(
  values: FormValues
): TermLinkCreationPayload {
  return {
    label: values.label ?? "",
    url: values.url ?? "",
  };
}

export function convertFormValuesToTermLinkUpdatePayload(
  values: FormValues
): TermLinkUpdatePayload {
  return {
    label: values.label,
    url: values.url,
  };
}
